<template>
  <vv-box :title="title" unpadded>
    <div class="vv-star-notation">
      <p>{{ question }}</p>
      <span v-for="n in 5" :key="n">
        <!-- TODO: how does 3x work ?? -->
        <img
          v-if="value >= n"
          class="star"
          alt="full star"
          src="../../assets/full-star@3x.png"
          @click="() => changeValue(n)"
        />
        <img
          v-else
          class="star"
          alt="empty star"
          src="../../assets/empty-star@3x.png"
          @click="() => changeValue(n)"
        />
      </span>
    </div>
  </vv-box>
</template>

<script>
import { VvBox } from './'

export default {
  name: 'VvStarNotation',
  model: {
    prop: 'value',
    event: 'input'
  },
  components: {
    VvBox
  },
  props: {
    question: String,
    title: String,
    value: Number
  },
  methods: {
    changeValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.vv-star-notation {
  padding-top: 25px;
  padding-bottom: 40px;
  text-align: center;
  font-size: 16px;

  & p {
    margin-top: 0px;
  }

  & .star {
    width: 36px;
    height: 34px;
  }
}
</style>
